module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cep-system-message"
  }, [_c('div', {
    staticClass: "cep-system-avatar"
  }, [_vm._v("N")]), _vm._v(" "), _c('div', {
    staticClass: "cep-system-message-body"
  }, [_c('div', {
    staticClass: "cep-system-bubble"
  }, [(_vm.content && _vm.content.length) ? _vm._l((_vm.content), function(el, i) {
    return _c('div', {
      key: i,
      staticClass: "cep-content-block"
    }, [(el.type === 'text') ? _c('p', {
      staticClass: "cep-text",
      domProps: {
        "innerHTML": _vm._s(_vm.renderText(el.value))
      }
    }) : (el.type === 'tags') ? _c('div', {
      staticClass: "cep-tags"
    }, _vm._l((el.items), function(tag, j) {
      return _c('span', {
        key: j,
        staticClass: "cep-tag"
      }, [_c('span', {
        staticClass: "cep-tag-check"
      }, [_vm._v("✓")]), _vm._v(" " + _vm._s(tag) + "\n            ")])
    }), 0) : (el.type === 'suggestion') ? _c('p', {
      staticClass: "cep-suggestion"
    }, [_vm._v("\n            " + _vm._s(el.label) + " "), _c('strong', [_vm._v(_vm._s(el.value))])]) : (el.type === 'buttons') ? _c('div', {
      staticClass: "cep-buttons"
    }, _vm._l((el.items), function(btn, j) {
      return _c('button', {
        key: j,
        class: ['cep-btn', btn.variant === 'primary' ? 'cep-btn-primary' : 'cep-btn-outline'],
        attrs: {
          "disabled": !_vm.isLast || btn.disabled
        },
        on: {
          "click": function($event) {
            return _vm.$emit('action', {
              type: 'button',
              value: btn.value,
              elementIndex: i
            })
          }
        }
      }, [_vm._v(_vm._s(btn.label))])
    }), 0) : (el.type === 'chips') ? _c('div', {
      staticClass: "cep-chips"
    }, _vm._l((el.items), function(chip, j) {
      return _c('button', {
        key: j,
        class: ['cep-chip', _vm.chipVariantClass(chip), el.selected === _vm.chipValue(chip) ? 'cep-chip-selected' : ''],
        attrs: {
          "disabled": !_vm.isLast || _vm.chipDisabled(chip)
        },
        on: {
          "click": function($event) {
            _vm.$emit('action', {
              type: 'chip',
              value: _vm.chipValue(chip),
              elementIndex: i
            })
          }
        }
      }, [(_vm.chipSubtitle(chip)) ? _c('span', {
        staticClass: "cep-chip-label"
      }, [_vm._v(_vm._s(_vm.chipLabel(chip)))]) : [_vm._v(_vm._s(_vm.chipLabel(chip)))], _vm._v(" "), (_vm.chipSubtitle(chip)) ? _c('span', {
        staticClass: "cep-chip-subtitle"
      }, [_vm._v(_vm._s(_vm.chipSubtitle(chip)))]) : _vm._e()], 2)
    }), 0) : (el.type === 'multi_chips') ? _c('div', {
      staticClass: "cep-chips-multi"
    }, [_c('div', {
      staticClass: "cep-chips"
    }, _vm._l((el.items), function(chip, j) {
      return _c('button', {
        key: j,
        class: ['cep-chip', _vm.multiSelections[i] && _vm.multiSelections[i].includes(chip) ? 'cep-chip-selected' : ''],
        attrs: {
          "disabled": !_vm.isLast
        },
        on: {
          "click": function($event) {
            return _vm.toggleMultiChip(i, chip)
          }
        }
      }, [_vm._v(_vm._s(chip))])
    }), 0), _vm._v(" "), _c('button', {
      staticClass: "cep-btn cep-btn-primary cep-multi-confirm",
      attrs: {
        "disabled": !_vm.isLast || !_vm.multiSelections[i] || !_vm.multiSelections[i].length
      },
      on: {
        "click": function($event) {
          return _vm.$emit('action', {
            type: 'chip-multi-confirm',
            value: _vm.multiSelections[i],
            elementIndex: i
          })
        }
      }
    }, [_vm._v(_vm._s(el.confirmButton))])]) : (el.type === 'cards') ? _c('div', {
      staticClass: "cep-cards"
    }, [(el.forceCards || el.items.length <= 5) ? [_c('div', {
      class: ['cep-cards-list', {
        'cep-cards-list-scroll': el.items.length > 5
      }]
    }, _vm._l((el.items), function(card, j) {
      return _c('div', {
        key: j,
        class: ['cep-card', _vm.cardSelections[i] === j ? 'cep-card-selected' : '', !_vm.isLast ? 'cep-card-disabled' : ''],
        on: {
          "click": function($event) {
            _vm.isLast && _vm.$set(_vm.cardSelections, i, j)
          }
        }
      }, [_c('strong', [_vm._v(_vm._s(card.title))]), _vm._v(" "), (card.subtitle) ? _c('span', {
        staticClass: "cep-card-subtitle"
      }, [_vm._v(_vm._s(card.subtitle))]) : _vm._e(), _vm._v(" "), (card.preview) ? _c('p', {
        staticClass: "cep-card-preview"
      }, [_vm._v(_vm._s(card.preview))]) : _vm._e(), _vm._v(" "), (card.media) ? _c('media-preview', {
        attrs: {
          "compact": "",
          "show-caption": false,
          "format": card.media.format,
          "media-id": card.media.mediaId,
          "media-name": card.media.mediaName || '',
          "file-name": card.media.fileName || '',
          "country-id": card.media.countryId,
          "language-id": card.media.languageId
        }
      }) : _vm._e()], 1)
    }), 0)] : [_c('nv-select', {
      staticClass: "cep-form-select cep-card-dropdown",
      attrs: {
        "disabled": !_vm.isLast,
        "value": _vm.cardSelections[i] !== undefined ? _vm.cardSelections[i] : ''
      },
      on: {
        "change": function($event) {
          _vm.isLast && _vm.$set(_vm.cardSelections, i, parseInt($event.target.value))
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "disabled": ""
      }
    }, [_vm._v("Select an option…")]), _vm._v(" "), _vm._l((el.items), function(card, j) {
      return _c('option', {
        key: j,
        domProps: {
          "value": j
        }
      }, [_vm._v(_vm._s(card.title))])
    })], 2), _vm._v(" "), (_vm.cardSelections[i] !== undefined && el.items[_vm.cardSelections[i]] && (el.items[_vm.cardSelections[i]].subtitle || el.items[_vm.cardSelections[i]].preview)) ? _c('div', {
      staticClass: "cep-card-dropdown-preview"
    }, [(el.items[_vm.cardSelections[i]].subtitle) ? _c('span', {
      staticClass: "cep-card-subtitle"
    }, [_vm._v(_vm._s(el.items[_vm.cardSelections[i]].subtitle))]) : _vm._e(), _vm._v(" "), (el.items[_vm.cardSelections[i]].preview) ? _c('p', {
      staticClass: "cep-card-preview"
    }, [_vm._v(_vm._s(el.items[_vm.cardSelections[i]].preview))]) : _vm._e()]) : _vm._e()], _vm._v(" "), (el.confirmButton) ? _c('div', {
      staticClass: "cep-buttons"
    }, [_c('button', {
      staticClass: "cep-btn cep-btn-primary",
      attrs: {
        "disabled": !_vm.isLast || _vm.cardSelections[i] === undefined
      },
      on: {
        "click": function($event) {
          return _vm.$emit('action', {
            type: 'card-confirm',
            value: _vm.cardSelections[i],
            elementIndex: i
          })
        }
      }
    }, [_vm._v(_vm._s(el.confirmButton))]), _vm._v(" "), (_vm.isLast && _vm.cardSelections[i] === undefined) ? _c('span', {
      staticClass: "cep-card-hint"
    }, [_vm._v("Select an option above first")]) : _vm._e()]) : _vm._e()], 2) : (el.type === 'badge-row') ? _c('div', {
      staticClass: "cep-badge-row"
    }, _vm._l((el.items), function(badge, j) {
      return _c('span', {
        key: j,
        staticClass: "cep-badge"
      }, [_vm._v("\n              " + _vm._s(badge.label) + ": "), _c('strong', [_vm._v(_vm._s(badge.value))])])
    }), 0) : (el.type === 'config') ? _c('div', {
      staticClass: "cep-config"
    }, _vm._l((el.items), function(item, j) {
      return _c('div', {
        key: j,
        staticClass: "cep-config-row"
      }, [_c('span', {
        staticClass: "cep-config-label"
      }, [_vm._v(_vm._s(item.label) + ":")]), _vm._v(" "), _c('span', {
        staticClass: "cep-config-value"
      }, [_vm._v(_vm._s(item.value))])])
    }), 0) : (el.type === 'form') ? _c('div', {
      staticClass: "cep-form"
    }, [_c('div', {
      staticClass: "cep-form-grid"
    }, _vm._l((el.fields), function(field, j) {
      return _c('div', {
        key: j,
        staticClass: "cep-form-field"
      }, [_c('label', {
        staticClass: "cep-form-label"
      }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), (field.type === 'select') ? _c('nv-select', {
        staticClass: "cep-form-select",
        model: {
          value: (_vm.formState[i][field.name]),
          callback: function($$v) {
            _vm.$set(_vm.formState[i], field.name, $$v)
          },
          expression: "formState[i][field.name]"
        }
      }, [_c('option', {
        attrs: {
          "value": "",
          "disabled": ""
        }
      }, [_vm._v(_vm._s(field.placeholder || 'Select…'))]), _vm._v(" "), _vm._l((field.options), function(opt) {
        return _c('option', {
          key: opt,
          domProps: {
            "value": opt
          }
        }, [_vm._v(_vm._s(opt))])
      })], 2) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.formState[i][field.name]),
          expression: "formState[i][field.name]"
        }],
        staticClass: "cep-form-input",
        attrs: {
          "placeholder": field.placeholder || ''
        },
        domProps: {
          "value": (_vm.formState[i][field.name])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.formState[i], field.name, $event.target.value)
          }
        }
      })], 1)
    }), 0), _vm._v(" "), _c('button', {
      staticClass: "cep-btn cep-btn-primary",
      attrs: {
        "disabled": !_vm.isLast
      },
      on: {
        "click": function($event) {
          return _vm.$emit('action', {
            type: 'form',
            value: _vm.formState[i],
            elementIndex: i
          })
        }
      }
    }, [_vm._v(_vm._s(el.button))])]) : (el.type === 'content-editor') ? _c('div', {
      staticClass: "cep-content-editor"
    }, [_vm._l((el.languages), function(lang) {
      return _c('div', {
        key: lang,
        staticClass: "cep-lang-block"
      }, [_c('div', {
        staticClass: "cep-lang-name"
      }, [_vm._v(_vm._s(lang))]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editorState[i][lang]),
          expression: "editorState[i][lang]"
        }],
        staticClass: "cep-lang-textarea",
        attrs: {
          "rows": "4",
          "disabled": !_vm.isLast || el.readOnly
        },
        domProps: {
          "value": (_vm.editorState[i][lang])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.editorState[i], lang, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "cep-lang-meta"
      }, [_c('span', {
        staticClass: "cep-char-count"
      }, [_vm._v(_vm._s((_vm.editorState[i][lang] || '').length) + " / 1024 chars")]), _vm._v(" "), _c('span', {
        staticClass: "cep-flag-ok"
      }, [_vm._v("✓ Clinical check passed")])])])
    }), _vm._v(" "), (!el.readOnly) ? [_c('div', {
      staticClass: "cep-regen-row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.regenNote[i]),
        expression: "regenNote[i]"
      }],
      staticClass: "cep-form-input cep-regen-input",
      attrs: {
        "type": "text",
        "placeholder": "Optional: tell it what to change, e.g. \"make it shorter\"",
        "disabled": !_vm.isLast
      },
      domProps: {
        "value": (_vm.regenNote[i])
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.isLast && _vm.$emit('action', {
            type: 'content-regenerate',
            value: _vm.regenNote[i],
            elementIndex: i
          })
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.regenNote, i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "cep-buttons"
    }, [_c('button', {
      staticClass: "cep-btn cep-btn-outline",
      attrs: {
        "disabled": !_vm.isLast
      },
      on: {
        "click": function($event) {
          return _vm.$emit('action', {
            type: 'content-regenerate',
            value: _vm.regenNote[i],
            elementIndex: i
          })
        }
      }
    }, [_vm._v("🔄 Regenerate")]), _vm._v(" "), _c('button', {
      staticClass: "cep-btn cep-btn-primary",
      attrs: {
        "disabled": !_vm.isLast
      },
      on: {
        "click": function($event) {
          return _vm.$emit('action', {
            type: 'content-confirm',
            value: _vm.editorState[i],
            elementIndex: i
          })
        }
      }
    }, [_vm._v(_vm._s(el.confirmButton))])])] : _c('div', {
      staticClass: "cep-buttons"
    }, [_c('button', {
      staticClass: "cep-btn cep-btn-primary",
      attrs: {
        "disabled": !_vm.isLast
      },
      on: {
        "click": function($event) {
          return _vm.$emit('action', {
            type: 'content-confirm',
            value: _vm.editorState[i],
            elementIndex: i
          })
        }
      }
    }, [_vm._v(_vm._s(el.confirmButton))])])], 2) : (el.type === 'upload') ? _c('div', {
      staticClass: "cep-upload"
    }, [_c('div', {
      staticClass: "cep-upload-zone",
      on: {
        "click": function($event) {
          _vm.$refs['upload-' + i][0].click()
        },
        "dragover": function($event) {
          $event.preventDefault();
        },
        "drop": function($event) {
          $event.preventDefault();
          return _vm.handleDrop($event, i)
        }
      }
    }, [_c('span', {
      staticClass: "cep-upload-icon"
    }, [_vm._v("🖼")]), _vm._v(" "), _c('span', [_c('strong', {
      staticClass: "cep-upload-link"
    }, [_vm._v(_vm._s(el.label))]), _vm._v("\n                " + _vm._s(el.hint ? ' or drag & drop — ' + el.hint : '') + "\n              ")]), _vm._v(" "), _c('input', {
      ref: 'upload-' + i,
      refInFor: true,
      staticClass: "cep-upload-input",
      attrs: {
        "type": "file",
        "accept": el.accept || 'image/*'
      },
      on: {
        "change": function($event) {
          return _vm.handleFileChange($event, i)
        }
      }
    })]), _vm._v(" "), (el.skipLabel) ? _c('button', {
      staticClass: "cep-btn cep-btn-outline cep-upload-skip",
      on: {
        "click": function($event) {
          return _vm.$emit('action', {
            type: 'upload-skip',
            elementIndex: i
          })
        }
      }
    }, [_vm._v(_vm._s(el.skipLabel))]) : _vm._e()]) : (el.type === 'media') ? _c('div', {
      staticClass: "cep-media"
    }, [_c('media-preview', {
      attrs: {
        "format": el.media.format,
        "media-id": el.media.mediaId,
        "media-name": el.media.mediaName || '',
        "file-name": el.media.fileName || '',
        "country-id": el.media.countryId,
        "language-id": el.media.languageId
      }
    })], 1) : (el.type === 'link') ? _c('router-link', {
      staticClass: "cep-link",
      attrs: {
        "to": el.to,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(el.label))]) : _vm._e()], 1)
  }) : (_vm.streaming && !_vm.text) ? _c('span', {
    staticClass: "cep-typing"
  }, [_c('span', {
    staticClass: "cep-typing-dot"
  }), _c('span', {
    staticClass: "cep-typing-dot"
  }), _c('span', {
    staticClass: "cep-typing-dot"
  })]) : _c('span', [_vm._v(_vm._s(_vm.text))])], 2), _vm._v(" "), (_vm.isDebugMode) ? _c('div', {
    staticClass: "cep-debug-bar"
  }, [_c('span', {
    staticClass: "cep-debug-time"
  }, [_vm._v(_vm._s(_vm.formattedTime))]), _vm._v(" "), _c('button', {
    staticClass: "cep-debug-copy",
    class: {
      copied: _vm.copySuccess
    },
    attrs: {
      "title": _vm.copySuccess ? 'Copied' : 'Copy'
    },
    on: {
      "click": _vm.copyMessage
    }
  }, [(!_vm.copySuccess) ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "9",
      "y": "9",
      "width": "13",
      "height": "13",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-243f12d4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chat-panel/SystemMessage.vue
// module id = Q1kX
// module chunks = 1